/**
 * DreamPay Private API
 * Private API v2 - Current version with JWT authentication, role-based access control, and enhanced security features.
 *
 * The version of the OpenAPI document: v2
 * Contact: suporte@dreampay.com.br
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface ExternalLogEntryCreateDtoV2 {
  correlationId?: string | null;
  source?: string | null;
  timestamp: string;
  level: string;
  message: string;
  messageTemplate?: string | null;
  properties?: string | null;
  exception?: string | null;
  sourceContext?: string | null;
  actionName?: string | null;
  operationName?: string | null;
  operationDurationMs?: number | null;
  parentOperationId?: string | null;
}
